
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Date {
    getWeekNumber: () => number
    format: (format: string, locale?: string | null) => string
    plus: (type: string, count: number) => Date
    minus: (type: string, count: number) => Date
}

const dateTypes = {
    second: 'etSeconds',
    minute: 'etMinutes',
    hour: 'etHours',
    date: 'etDate',
    month: 'etMonth',
    year: 'etFullYear',
    'week-day': 'etDay',
}

// eslint-disable-next-line no-extend-native
Date.prototype.plus = function (type, count) {
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    this['s' + dateTypes[type]](this['g' + dateTypes[type]]() + count)
    return this
}
// eslint-disable-next-line no-extend-native
Date.prototype.minus = function (type, count) {
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    this['s' + dateTypes[type]](this['g' + dateTypes[type]]() - count)
    return this
}

enum dateFormats {
    Y = 'getFullYear',
    y = 'getFullYear',
    M = 'getMonth',
    m = 'getMonth',
    D = 'getDate',
    d = 'getDate',
    H = 'getHours',
    h = 'getHours',
    I = 'getMinutes',
    i = 'getMinutes',
    S = 'getSeconds',
    s = 'getSeconds',
    W = 'getDay',
    w = 'getDay'
}

function getLocaleString(data: {str: string, date: Date, locale: string | null}) {
    const keys = {
        W: "weekday",
        w: "short-weekday",
        Y: "year",
        y: "short-year",
        M: "month" + (!!data?.locale ? "-name" : ""),
        m: "short-month" + (!!data?.locale ? "-name" : ""),
        D: "day",
        d: "short-day",
        H: "hour",
        h: "short-hour",
        I: "minute",
        i: "short-minute",
        S: "second",
        s: "short-second",
    }
    const values = {
        // era: "long", // "narrow" | "short" | "long"

        weekday: "long", // "narrow" | "short" | "long"
        'short-weekday': "short",
        year: "numeric",
        'short-year': "2-digit",
        month: "2-digit", // "narrow" | "short" | "long"
        'short-month': "numeric",
        'month-name': "long",
        'short-month-name': "short",
        day: "2-digit",
        'short-day': "numeric",
        hour: "2-digit",
        'short-hour': "numeric",
        minute: "2-digit",
        'short-minute': "numeric",
        second: "2-digit",
        'short-second': "numeric",
    }

    // @ts-expect-error
    const [key, value] = [keys?.[data?.str?.toUpperCase?.()]?.replace?.('-name', ''), values?.[keys?.[data?.str]]]

	const result = data.date.toLocaleString(data.locale ?? 'ru', {
        // @ts-expect-error
        timezone: "UTC",
        [key]: value,
        hour12: false,
	});

    return result?.length < 2 ? result.padStart(2, "0") : result;
}

// eslint-disable-next-line no-extend-native
Date.prototype.format = function (format: string, locale: (string | null) = null) {
    return format?.split('')
        ?.map(str => (
            // @ts-expect-error
            dateFormats?.[str]
                ? getLocaleString({ str: str, date: this, locale: locale })
                : str
        ))
        ?.join('')
}
